module.exports = __webpack_public_path__ + "img/80.4ed2630a.png";